import { LiaCogSolid } from "react-icons/lia";
import { PiChatCircleBold } from "react-icons/pi";
import { IoInformationCircleOutline } from "react-icons/io5";
import { FiLayers } from "react-icons/fi";

export const routes = [
  {
    title: "Services",
    href: "#services",
    Icon: LiaCogSolid,
  },
  {
    title: "Products",
    href: "#portfolio",
    Icon: FiLayers,
  },
  {
    title: "About Us",
    href: "#about",
    Icon: IoInformationCircleOutline,
  },
  {
    title: "Contact Us",
    href: "#contact",
    Icon: PiChatCircleBold,
  },
];